import DrawerHeader from '@/components/atoms/DrawerHeader';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import { Drawer } from 'antd';
import { ReactElement } from 'react';
import { useDispatch } from 'react-redux';

export interface CustomDrawerProps {
  title: string;
  listOfIds: string[] | [];
  children: ReactElement;
}

export default function CustomDrawer({
  title,
  listOfIds,
  children,
}: CustomDrawerProps) {
  const dispatch = useDispatch();
  const { modalId } = usePublicState();
  const indexOfId = listOfIds?.findIndex((el) => el === modalId);

  const handlePrev = () =>
    dispatch(setModalId({ id: listOfIds[indexOfId - 1] }));

  const handleNext = () =>
    dispatch(setModalId({ id: listOfIds[indexOfId + 1] }));

  const handleClose = () => dispatch(setModalId(null));

  return (
    <Drawer
      title={
        <DrawerHeader
          title={title}
          onNext={handleNext}
          onPrev={handlePrev}
          nextDisabled={indexOfId === listOfIds?.length - 1}
          prevDisabled={indexOfId === 0}
          onClose={handleClose}
        />
      }
      onClose={handleClose}
      open={!!modalId && modalId === listOfIds[indexOfId]}
      width={864}
      destroyOnClose
      closeIcon={null}
    >
      {children}
    </Drawer>
  );
}
